/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StoryblokSearchService {
    /**
     * Storyblok stories search
     * @returns any Success
     * @throws ApiError
     */
    public static getApiVStoryblokSearch({
        type,
        q,
        offset,
        limit,
        apiVersion = 1,
    }: {
        type: 'blog' | 'recipes',
        q: string,
        offset: number,
        limit: number,
        apiVersion?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/storyblok/search/{type}',
            path: {
                'apiVersion': apiVersion,
                'type': type,
            },
            query: {
                'q': q,
                'offset': offset,
                'limit': limit,
            },
            errors: {
                400: `Validation error.`,
            },
        });
    }
}
